import { DEFAULT_FEATURE_FLAG_SUPPORTED_TARGET_TYPES } from './feature-flags.constants';
import type { FeatureFlagDefinitionEntryInput } from './feature-flags.constants';
import { DISCOVERY_FEATURE_FLAG_DEFINITIONS } from './feature-flag-definitions-discovery';
import { GENERAL_FEATURE_FLAG_DEFINITIONS } from './feature-flag-definitions-general';
import { PRODUCT_FEATURE_FLAG_DEFINITIONS } from './feature-flag-definitions-product';
import { SURFACE_FEATURE_FLAG_DEFINITIONS } from './feature-flag-definitions-surfaces';

const FEATURE_FLAG_DEFINITION_ENTRIES = [
  ...GENERAL_FEATURE_FLAG_DEFINITIONS,
  ...DISCOVERY_FEATURE_FLAG_DEFINITIONS,
  ...SURFACE_FEATURE_FLAG_DEFINITIONS,
  ...PRODUCT_FEATURE_FLAG_DEFINITIONS,
] as const satisfies readonly FeatureFlagDefinitionEntryInput[];

export const FEATURE_FLAG_DEFINITIONS = FEATURE_FLAG_DEFINITION_ENTRIES.map(
  (definition) => {
    const entry: FeatureFlagDefinitionEntryInput = definition;

    return {
      ...definition,
      supportedTargetTypes:
        entry.supportedTargetTypes ??
        DEFAULT_FEATURE_FLAG_SUPPORTED_TARGET_TYPES,
    };
  },
);

export const DEFAULT_TENANT_FEATURE_FLAGS = Object.fromEntries(
  FEATURE_FLAG_DEFINITIONS.map((definition) => [
    definition.name,
    definition.defaultValue,
  ]),
);

export type FeatureFlagName =
  (typeof FEATURE_FLAG_DEFINITION_ENTRIES)[number]['name'];

export type FeatureFlagDefinition = (typeof FEATURE_FLAG_DEFINITIONS)[number];

export const FEATURE_FLAG_NAMES = [
  FEATURE_FLAG_DEFINITION_ENTRIES[0].name,
  ...FEATURE_FLAG_DEFINITION_ENTRIES.slice(1).map(
    (definition) => definition.name,
  ),
] as const;

type FlagTypeToValue = {
  BOOLEAN: boolean;
  NUMBER: number;
  STRING: string;
  TIMESTAMP: number;
};

export type FeatureFlagValueByKey<K extends FeatureFlagName> =
  FlagTypeToValue[Extract<FeatureFlagDefinition, { name: K }>['type']];
